import { render, staticRenderFns } from "./customerFollow.vue?vue&type=template&id=ee67940e&scoped=true&"
import script from "./customerFollow.vue?vue&type=script&lang=js&"
export * from "./customerFollow.vue?vue&type=script&lang=js&"
import style0 from "./customerFollow.vue?vue&type=style&index=0&id=ee67940e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee67940e",
  null
  
)

export default component.exports